import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import copy from 'copy-to-clipboard';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../../components/DataNotFound';
import SearchFilters from '../../../../../components/elements/SearchFilter';
import Userbanner from '../../../../../components/elements/Userbanner';
import { getFromLocalStorage } from '../../../../../components/helper/authorizationHelper';
import { getAsync, postAsync, reactURL } from '../../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../../components/helper/downloadCSVHelper';
import { updateGwaRegisterList } from '../../../../../features/GWARegisterListSlice';
import LoadingAnimation from '../../../../../components/LoadingAnimation';
import { PageHitCountApi } from '../../../../../shared/Helper';
import { useLocation } from 'react-use';
import { printTable } from '../../../../../utils/tableExportUtils';
const GWAProjectList = () => {
  const apiData = useSelector((state) => state.gwaprojectList.list);
  const isActive = useSelector((state) => state.toggle.isActive);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  // const [serviceCheck, setServiceCheck] = useState(false);
  // const [serviceMessage, setServiceMessage] = useState("");
  const [serviceCheck, setServiceCheck] = useState({
    serviceShow: false,
    statusCode: 0,
    message: '',
  });
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [userActive, setUserActive] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [epUserID, setEpUserID] = useState(null);
  const [next, setNext] = useState(1);
  const [order, setOrder] = useState(0);
  const [sortOrder, setSortOrder] = useState('asc');

  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const token = localStorage.getItem('token');

  const isLogin = () => {
    if (!token && !epUserID) {
      window.location.href = '/donorLogin';
    }
  };

  const pageOptions = {
    pageNo: 1,
    pageSize: 20,
  };

  const handleCopy = async (e, gwaProjectID, projectTypeIdInt) => {
    console.log(projectTypeIdInt, 'projectTypeIdInt');
    e.preventDefault();
    try {
      getAsync('GWAProject/GetGWAProjectById', { id: gwaProjectID })
        .then((response) => {
          const result = response?.data[0];
          if (
            result?.referralLink === undefined ||
            result?.referralLink === null ||
            result?.referralLink === 0 ||
            result?.projectGUID === undefined ||
            result?.projectGUID === null ||
            result?.projectGUID === ''
          ) {
            toast.warning(`${t('Failed to copy refferal link data not found')}`);
          } else {
            const gwaReferralLink = `${reactURL}/PaymentProcess/${result?.projectGUID}/${result?.referralLink}/${3}/${projectTypeIdInt}`;
            copy(gwaReferralLink);
            toast.success(`${t('Link copy Successfully')}`);
          }
        })
        .catch((err) => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    } catch (error) {
      console.error('Error fetching record:', error);
    }
  };

  const bodyGet = {
    epUserID: parseInt(epUserID),
    dateFrom: dateFrom,
    dateTo: dateTo,
    order: order,
  };

  const getData = async () => {
    setIsLoad(true);
    await postAsync('GWAProject/GetGWAProjectFilterList/' + pageOptions.pageNo + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setIsLoad(false);
        setPageCount(response?.page);
        if (response.statusCode === 422) {
          setServiceCheck((prevState) => ({
            ...prevState,
            serviceShow: true,
            statusCode: 422,
            message: response.message,
          }));
        } else if (response.statusCode === 406) {
          setServiceCheck((prevState) => ({
            ...prevState,
            serviceShow: true,
            statusCode: 406,
            message: response.message,
          }));
        } else if (response.statusCode === 426) {
          setServiceCheck((prevState) => ({
            ...prevState,
            serviceShow: true,
            statusCode: 426,
            message: response.message,
          }));
        } else if (response.statusCode === 423) {
          setServiceCheck((prevState) => ({
            ...prevState,
            serviceShow: true,
            statusCode: 423,
            message: response.message,
          }));
        } else if (response?.statusCode == 204) {
          setDatanotfound(true);
          setPageCount(response?.page);
        } else {
          dispatch(updateGwaRegisterList(response?.data));
          setNext(pageOptions.pageNo);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const sortDataByDate = () => {
    // const sortedData = [...apiData].sort((a, b) => {
    //   const dateA = moment(a.date, 'DD/MM/YYYY').toDate();
    //   const dateB = moment(b.date, 'DD/MM/YYYY').toDate();
    // if (sortOrder === 'asc') {
    //   setOrder(0);
    // } else {
    //   setOrder(0);
    // }
    // });
    // return sortedData;
  };

  const toggleSortOrder = () => {
    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
  };

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

    localStorage.setItem('isHome', false);
    isLogin();

    if (epUserID !== null) {
      getData();
      PageHitCountApi(pathname, epUserID);
    }
  }, [epUserID, order]);

  const handleRoute = (id) => {
    const link = '/GWAProjectView/';
    navigate(link, { state: { id: id } });
  };

  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;

    return (
      <Table.Row items={apiData} key={data?.gwaProjectID}>
        <Table.Cell className="whitespace-nowrap">{sno}</Table.Cell>
        <Table.Cell className="whitespace-nowrap">
          {isActive ? data?.projectNameAR || 'N/A' : data?.projectNameAR || 'N/A'}
        </Table.Cell>
        <Table.Cell className="whitespace-nowrap">{data?.projectNotes || 'N/A'}</Table.Cell>
        <Table.Cell className="whitespace-nowrap">{t(data?.maProjectNotes) || t('Pending')}</Table.Cell>
        <Table.Cell className="whitespace-nowrap">{data?.date || 'N/A'}</Table.Cell>
        <Table.Cell className="whitespace-nowrap">{data?.timeNow || 'N/A'}</Table.Cell>
        <Table.Cell className="whitespace-nowrap">
          <button
            onClick={() => handleRoute(data?.gwaProjectID)}
            className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
          >
            <VisibilityOutlinedIcon />
          </button>
        </Table.Cell>
        <Table.Cell className="whitespace-nowrap">
          {data?.maProjectApproveID === 1 && (
            <button
              className="text-customgreen hover:text-white border-2 border-customgreen hover:bg-hovergreen focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-sm px-3 py-2 text-center "
              onClick={(e) => handleCopy(e, data?.gwaProjectID, data?.projectTypeIdInt)}
            >
              <LinkOutlinedIcon />
              {t('Get Link')}
            </button>
          )}
        </Table.Cell>
      </Table.Row>
    );
  });

  const SearchFilter = {
    epUserID: epUserID,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
    order: order,
  };

  const getPaginationList = async () => {
    try {
      setIsLoad(true);
      setDatanotfound(false);
      const response = await postAsync(
        `GWAProject/GetGWAProjectFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
        SearchFilter,
      );
      if (response) {
        setIsLoad(false);
        setPageCount(response.page);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
      dispatch(updateGwaRegisterList(response.data));
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    await getPaginationList();
  };

  const changePage = async ({ selected }) => {
    const select = selected + 1;
    await postAsync('GWAProject/GetGWAProjectFilterList/' + select + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        dispatch(updateGwaRegisterList(response?.data));
        setPageCount(response?.page);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      [t('S.No')]: ii + 1,
      [t('Project Name')]: isActive ? item.projectNameAR : item.projectName,
      [t('Project Notes')]: item.projectNotes,
      [t('Managed Project Notes')]: item.maProjectNotes,
      [t('Date')]: item.date,
      [t('Time')]: item.timeNow,
    }));
    downloadCSV(filteredData, 'Good Will Ambassador Project List');
  };
// const handlePrint = (e) => {
//   e.preventDefault();
  
//   // Direction decide करें isActive के based पर
//   const direction = isActive ? 'rtl' : 'ltr';
  
//   // Original content ko store karein
//   const originalContent = document.body.innerHTML;
  
//   // Print content ko prepare karein
//   const printContent = document.createElement('div');
//   printContent.className = 'print-container';
  
//   // Heading
//   const heading = document.createElement('h1');
//   heading.className = 'print-heading';
//   heading.textContent = `${t('Project')} ${t('list')}`;
//   printContent.appendChild(heading);
  
//   // Table create karein
//   const table = document.createElement('table');
//   table.className = 'print-table';
  
//   // Table Header
//   const thead = document.createElement('thead');
//   thead.innerHTML = `
//     <tr>
//       <th>#</th>
//       <th>${t('Project Name')}</th>
//       <th>${t('Project Notes')}</th>
//       <th>${t('Managed Project Notes')}</th>
//       <th>${t('Date')}</th>
//       <th>${t('Time')}</th>
//     </tr>
//   `;
//   table.appendChild(thead);
  
//   // Table Body
//   const tbody = document.createElement('tbody');
//   apiData?.forEach((data, index) => {
//     const row = document.createElement('tr');
//     row.innerHTML = `
//       <td>${index + 1}</td>
//       <td>${isActive ? data?.projectNameAR || 'N/A' : data?.projectNameAR || 'N/A'}</td>
//       <td>${data?.projectNotes || 'N/A'}</td>
//       <td>${t(data?.maProjectNotes) || t('Pending')}</td>
//       <td>${data?.date || 'N/A'}</td>
//       <td>${data?.timeNow || 'N/A'}</td>
//     `;
//     tbody.appendChild(row);
//   });
//   table.appendChild(tbody);
//   printContent.appendChild(table);
  
//   // Temporary print window open karein
//   const printWindow = window.open('', '_blank');
//   printWindow.document.write(`
//     <html>
//       <head>
//         <title>${t('Project List')}</title>
//         <style>
//           body {
//             font-family: Arial, sans-serif;
//             margin: 20px;
//             direction: ${direction}; /* यहाँ direction set करें */
//             text-align: ${direction === 'rtl' ? 'right' : 'left'}; /* Text alignment bhi set करें */
//           }
//           .print-heading {
//             text-align: center;
//             color: #2f855a;
//             margin-bottom: 20px;
//             font-size: 24px;
//           }
//           .print-table {
//             width: 100%;
//             border-collapse: collapse;
//             direction: ${direction}; /* Table ki direction bhi same rakhein */
//           }
//           .print-table th {
//             background-color: #2f855a;
//             color: white;
//             padding: 10px;
//             border: 1px solid #ddd;
//             text-align: ${direction === 'rtl' ? 'right' : 'left'}; /* Header alignment */
//           }
//           .print-table td {
//             padding: 8px;
//             border: 1px solid #ddd;
//             text-align: ${direction === 'rtl' ? 'right' : 'left'}; /* Cell alignment */
//           }
//           .print-table tr:nth-child(even) {
//             background-color: #f9f9f9;
//           }
//           @media print {
//             @page {
//               margin: 0.5in;
//             }
//             body {
//               margin: 0;
//               direction: ${direction}; /* Print time bhi direction maintain rakhein */
//             }
//           }
//         </style>
//       </head>
//       <body>
//         ${printContent.outerHTML}
//         <script>
//           window.onload = function() {
//             window.print();
//             window.onafterprint = function() {
//               window.close();
//             };
//           };
//         </script>
//       </body>
//     </html>
//   `);
//   printWindow.document.close();
// };

// const handlePrint = (e) => {
//   e.preventDefault();
  
//   // Original content ko store karein
//   const originalContent = document.body.innerHTML;
  
//   // Print content ko prepare karein
//   const printContent = document.createElement('div');
//   printContent.className = 'print-container';
  
//   // Heading
//   const heading = document.createElement('h1');
//   heading.className = 'print-heading';
//   heading.textContent = `${t('Project')} ${t('list')}`;
//   printContent.appendChild(heading);
  
//   // Table create karein
//   const table = document.createElement('table');
//   table.className = 'print-table';
  
//   // Table Header
//   const thead = document.createElement('thead');
//   thead.innerHTML = `
//     <tr>
//       <th>#</th>
//       <th>${t('Project Name')}</th>
//       <th>${t('Project Notes')}</th>
//       <th>${t('Managed Project Notes')}</th>
//       <th>${t('Date')}</th>
//       <th>${t('Time')}</th>
//     </tr>
//   `;
//   table.appendChild(thead);
  
//   // Table Body
//   const tbody = document.createElement('tbody');
//   apiData?.forEach((data, index) => {
//     const row = document.createElement('tr');
//     row.innerHTML = `
//       <td>${index + 1}</td>
//       <td>${isActive ? data?.projectNameAR || 'N/A' : data?.projectNameAR || 'N/A'}</td>
//       <td>${data?.projectNotes || 'N/A'}</td>
//       <td>${t(data?.maProjectNotes) || t('Pending')}</td>
//       <td>${data?.date || 'N/A'}</td>
//       <td>${data?.timeNow || 'N/A'}</td>
//     `;
//     tbody.appendChild(row);
//   });
//   table.appendChild(tbody);
//   printContent.appendChild(table);
  
//   // Temporary print window open karein
//   const printWindow = window.open('', '_blank');
//   printWindow.document.write(`
//     <html>
//       <head>
//         <title>${t('Project List')}</title>
//         <style>
//           body {
//             font-family: Arial, sans-serif;
//             margin: 20px;
//           }
//           .print-heading {
//             text-align: center;
//             color: #2f855a;
//             margin-bottom: 20px;
//             font-size: 24px;
//           }
//           .print-table {
//             width: 100%;
//             border-collapse: collapse;
//           }
//           .print-table th {
//             background-color: #2f855a;
//             color: white;
//             padding: 10px;
//             border: 1px solid #ddd;
//             text-align: left;
//           }
//           .print-table td {
//             padding: 8px;
//             border: 1px solid #ddd;
//           }
//           .print-table tr:nth-child(even) {
//             background-color: #f9f9f9;
//           }
//           @media print {
//             @page {
//               margin: 0.5in;
//             }
//             body {
//               margin: 0;
//             }
//           }
//         </style>
//       </head>
//       <body>
//         ${printContent.outerHTML}
//         <script>
//           window.onload = function() {
//             window.print();
//             window.onafterprint = function() {
//               window.close();
//             };
//           };
//         </script>
//       </body>
//     </html>
//   `);
//   printWindow.document.close();
// };
  



// आपके component में


// फिर handlePrint function में:
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('Project Name'),
      accessor: (row) => isActive ? row?.projectNameAR || 'N/A' : row?.projectNameAR || 'N/A'
    },
    {
      header: t('Project Notes'),
      accessor: (row) => row?.projectNotes || 'N/A'
    },
    {
      header: t('Managed Project Notes'),
      accessor: (row, index, t) => t(row?.maProjectNotes) || t('Pending')
    },
    {
      header: t('Date'),
      accessor: (row) => row?.date || 'N/A'
    },
    {
      header: t('Time'),
      accessor: (row) => row?.timeNow || 'N/A'
    }
  ];
  
  // Call the reusable print function
  printTable({
    data: apiData || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Project')} ${t('list')}`,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
return (
    <div className="pt-12">
      {!isLogin ? (
        <h1>NOT AUTHORIZED</h1>
      ) : (
        <>
          <Userbanner />
          {!isLoad ? (
            serviceCheck.serviceShow ? (
              <>
                <section class="text-gray-600 body-font">
                  <div class="container mx-auto flex px-5  items-center justify-center flex-col">
                    <img
                      class="lg:w-1/3 md:w-3/6 w-5/6 object-cover object-center rounded"
                      alt="hero"
                      src="/assets/not-register.png"
                    />
                    <h1 className="text-center text-customgreen font-semibold text-2xl mt-5">
                      {t(serviceCheck.message)}
                    </h1>
                    {serviceCheck.statusCode === 423 ||
                    serviceCheck.statusCode === 406 ||
                    serviceCheck.statusCode === 426 ? (
                      <></>
                    ) : (
                      <Link to={'/GWARegister'}>
                        <p className="text-center text-blue-500 underline font-semibold ">
                          {t('Click here to register as Good Will Ambassador')}
                        </p>
                      </Link>
                    )}
                  </div>
                </section>
                {/* <Link to={'/GWARegister'}>
                  <p className="text-center text-blue-500 underline font-semibold ">
                    {t('Click here to register as Good Will Ambassador')}
                  </p>
                </Link> */}
              </>
            ) : userActive ? (
              <h1 className="text-center text-customgreen font-semibold text-2xl mt-5">
                {t('Your Good Will Ambassador Service has ben inactivated, please contact the Admin.')}
              </h1>
            ) : (
              <>
                <div className="container-fluid  ">
                  <div className="row text-center justify-center">
                    <div className="col-lg-11 ">
                      <div className="flex justify-end   my-4">
                        <Link className=" text-center" to="/GWAProjectRegister">
                          <button className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center">
                            {t('create')}
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="row  justify-center">
                    <SearchFilters
                      handleSearch={handleSearch}
                      setDateFrom={setDateFrom}
                      setDateTo={setDateTo}
                      dateTo={dateTo}
                      dateFrom={dateFrom}
                      handlePrint={handlePrint}
                      handleOnExport={handleOnExport}
                      heading={'Project List'}
                    />

                    <div className="col-lg-11 pt-9 py-10">
                      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                        <Table celled className="text-sm text-left rtl:text-right text-gray-500">
                          <Table.Header className="text-sm font-bold text-white bg-customgreen uppercase">
                            <Table.Row>
                              <Table.HeaderCell className="text-white items-center align-middle">
                                {t('sNo')}
                              </Table.HeaderCell>
                              <Table.HeaderCell className="text-white items-center align-middle">
                                {t('Project Name')}
                              </Table.HeaderCell>
                              <Table.HeaderCell className="text-white items-center align-middle">
                                {t('Project Notes')}
                              </Table.HeaderCell>
                              <Table.HeaderCell className="text-white items-center align-middle">
                                {t('Managed Project Notes')}
                              </Table.HeaderCell>
                              <Table.HeaderCell
                                className="text-white items-center align-middle"
                                onClick={() => {
                                  setOrder(order == 0 ? 1 : 0);
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                                {t('Date')}
                                {order ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />} {/* Add arrow indicator */}
                              </Table.HeaderCell>
                              <Table.HeaderCell className="text-white items-center align-middle">
                                {t('Time')}
                              </Table.HeaderCell>
                              <Table.HeaderCell className="text-white items-center align-middle">
                                {t('View')}
                              </Table.HeaderCell>
                              <Table.HeaderCell className="text-white items-center align-middle">
                                {t('Get Link')}
                              </Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>

                          <Table.Body>{displayRecords}</Table.Body>
                        </Table>{' '}
                        {datanotfound && <DataNotFound />}
                      </div>

                      {pageCount > 0 && (
                        <div className="flex flex-row px-12 justify-between">
                          <Menu pagination>
                            <Menu.Item>
                              <ReactPaginate
                                previousLabel={t('Previous')}
                                nextLabel={t('Next')}
                                pageCount={pageCount}
                                onPageChange={changePage}
                                containerClassName={'paginationButtons'}
                                previousLinkClassName={'previousButton'}
                                nextLinkClassName={'nextButton'}
                                disabledClassName={'paginationDisabled'}
                                activeClassName={'paginationActive'}
                              />
                            </Menu.Item>
                          </Menu>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )
          ) : (
            <LoadingAnimation
              imageStyling={''}
              styling={'flex items-center py-10  align-middle justify-center space-x-2'}
            />
          )}
        </>
      )}
    </div>
  );
};

export default GWAProjectList;
